"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var features = new Map();
var FeatureToggleService = (function () {
    function FeatureToggleService() {
        this.localStoragePrefix = '_feature';
        localStorage.setItem('_feature._enabled', JSON.stringify(true));
    }
    FeatureToggleService.clearInternalFeatureList = function () {
        features.clear();
    };
    FeatureToggleService.prototype.register = function (feature) {
        if (!feature.name) {
            feature.name = feature.key;
        }
        features.set(feature.key, feature.name);
        if (localStorage.getItem(this.localStorageKey(feature.key)) === null) {
            localStorage.setItem(this.localStorageKey(feature.key), JSON.stringify({ name: feature.name, enabled: false }));
        }
    };
    FeatureToggleService.prototype.tidyUpLocalStorageData = function () {
        var _this = this;
        var registeredFeatures = Array.from(features.keys());
        var keysInLocalStorage = Object.keys(localStorage)
            .filter(function (key) {
            return key.startsWith(_this.localStoragePrefix) &&
                key !== _this.localStoragePrefix + "._enabled";
        });
        keysInLocalStorage.forEach(function (key) {
            var feature = key.replace(_this.localStoragePrefix + ".", '');
            if (registeredFeatures.indexOf(feature) === -1) {
                localStorage.removeItem(key);
            }
        });
    };
    FeatureToggleService.prototype.check = function (featureKey) {
        if (!features.has(featureKey)) {
            console.warn("The feature " + featureKey + " has not been registered");
            return false;
        }
        var localStorageData = localStorage.getItem(this.localStorageKey(featureKey));
        return localStorageData === null ? false : JSON.parse(localStorageData).enabled;
    };
    FeatureToggleService.prototype.localStorageKey = function (featureKey) {
        return this.localStoragePrefix + "." + featureKey;
    };
    return FeatureToggleService;
}());
exports.FeatureToggleService = FeatureToggleService;
